import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, Award, Facebook, Linkedin } from "lucide-react";
import { Wordmark } from "@/components/Navbar";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-roch-navy text-white">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Wordmark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
            SARL créée en 1993 à Pontivy. 12 compagnons couvreurs et 2 chargés de
            projet au service du Morbihan et des Côtes d'Armor.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <span className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">
              <ShieldCheck className="h-3.5 w-3.5 text-roch-orange" /> Garantie décennale AXA
            </span>
            <span className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">
              <Award className="h-3.5 w-3.5 text-roch-orange" /> Certifié RGE
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-roch-orange">Navigation</p>
          <nav className="mt-5 flex flex-col gap-3">
            {[
              { to: "/", label: "Accueil" },
              { to: "/services", label: "Nos services" },
              { to: "/realisations", label: "Réalisations" },
              { to: "/devis", label: "Devis en ligne" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
                className="text-sm text-white/55 transition-colors hover:text-white"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-roch-orange">Contact</p>
          <div className="mt-5 flex flex-col gap-4 text-sm text-white/55">
            <a href="tel:+33297380540" data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-white">
              <Phone className="h-4 w-4 text-roch-orange" /> 02 97 38 05 40
            </a>
            <a href="mailto:contact@leroch-couverture.fr" data-testid="footer-email-link" className="flex items-center gap-3 transition-colors hover:text-white">
              <Mail className="h-4 w-4 text-roch-orange" /> contact@leroch-couverture.fr
            </a>
            <span className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-roch-orange" />
              ZA Kerponner Villeneuve Postic, 56300 Pontivy
            </span>
          </div>
          <div className="mt-6 flex items-center gap-2 rounded-xl border border-roch-orange/40 bg-roch-orange/10 px-4 py-3">
            <ShieldCheck className="h-4 w-4 shrink-0 text-roch-orange" />
            <span className="text-xs font-medium text-white/85">Assurances AXA — responsabilité civile & décennale</span>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
          © 2026 LE ROCH — Tous droits réservés
        </p>
        <div className="flex items-center gap-5">
          <a href="https://www.facebook.com/LerochCouverture" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="text-white/35 transition-colors hover:text-roch-orange" aria-label="Facebook">
            <Facebook className="h-4 w-4" />
          </a>
          <a href="https://www.linkedin.com/company/sarl-couverture-le-roch/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="text-white/35 transition-colors hover:text-roch-orange" aria-label="LinkedIn">
            <Linkedin className="h-4 w-4" />
          </a>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
            Pontivy · Morbihan · Côtes d'Armor
          </p>
        </div>
      </div>
    </div>
  </footer>
);
